import React, { forwardRef, useEffect, useState, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Title from "./Title";
import { useProjet } from "../Contexts/projet";
import {
  Button,
  Dialog,
  DialogContent,
  Fab,
  TextField,
  Typography,
  withStyles,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import Slide from "@material-ui/core/Slide";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useDropzone } from "react-dropzone";
import tasksAPI from "../Api/tasksAPI";
import attachmentAPI from "../Api/attachmentAPI";
import { useUser } from "../Contexts/user";

const useStyles = makeStyles((theme) => ({
  container: {
    overflowY: "none",
    position: "relative",
  },
  table: {
    marginTop: 20,
  },
  fabContainer: {
    position: "absolute !important",
    top: 10,
    right: 20,
  },
  fab: {
    marginLeft: "10px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  titleForm: {
    marginBottom: "30px",
  },
  contentForm: {},
  modal: {
    width: "300px",
  },
  actions: {
    display: "flex",
    justifyContent: "space-around",
  },
  itemAction: {
    marginLeft: "5px",
    marginRight: "5px",
  },
  butonAction: {
    marginLeft: "5px",
    marginRight: "5px",
    marginTop: "8px",
  },
  dialContent: {
    display: "flex",
    flexDirection: "column",
  },
  dialContentTitle: {
    marginBottom: "20px",
  },
  drop: {
    marginTop: "20px",
    height: "80px",
    border: "3px dashed #e84e24",
    display: "flex",
    justifyContent: "center",
    alignIteams: "center",
  },
}));

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function TasksTableClient() {
  const classes = useStyles();
  const {
    folder,
    tasks,
    getTimeTask,
    workflows,
    getWorkflowTask,
  } = useProjet();
  const [open, setOpen] = useState(false);
  const [times, setTimes] = useState([]);
  const {token} = useUser();

  // Modal properies & functions

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [files, setFiles] = useState([]);

  const onDrop = useCallback((acceptedFiles) => setFiles(acceptedFiles), []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const createTask = () => {
    setOpen(false);
    tasksAPI.createTasksFolder(token, folder.id, title, description).then((res) => {
      setTitle("");
      setDescription("");
      if(res.data) {
        attachFiles(res.data[0].id);
      }
    });
  };

  const attachFiles = (taskId) => {
    files.forEach((file) => {
      const reader = new FileReader();

      reader.onabort = () => console.log("file reading was aborted");
      reader.onerror = () => console.log("file reading has failed");
      reader.onload = () => {
        // Do whatever you want with the file contents
        const binaryStr = reader.result;
        attachmentAPI.uploadTaskAttachment(token, taskId, file, binaryStr);
      };
      reader.readAsArrayBuffer(file);
    });
    setFiles([]);
  };

  //

  useEffect(() => {
    if (Array.isArray(tasks)) setTimes(tasks.map(() => "00:00"));
  }, [tasks, getTimeTask, workflows, getWorkflowTask]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setTitle('');
    setDescription('');
    setFiles([])
    setOpen(false);
  };

  const onTimeChange = (index, value) => {
    setTimes((prev) => {
      prev[index] = value;
      return Array.from(prev);
    });
  };

  const getTypoColor = (workflow) => {
    const TextTypography = withStyles({
      root: {
        color: workflow.color.toLowerCase(),
      },
    })(Typography);
    return <TextTypography component="p">{workflow.name}</TextTypography>;
  };

  return (
    <>
      {tasks && (
        <div className={classes.container}>
          <div className={classes.fabContainer} onClick={handleClickOpen}>
            Ajouter une tache
            <Fab
              color="primary"
              aria-label="add"
              className={classes.fab}
              size="small"
            >
              <AddIcon />
            </Fab>
          </div>
          <Title>Liste des tâches </Title>
          <Table size="small" className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Date de début</TableCell>
                <TableCell>Date de fin</TableCell>
                <TableCell>Titre</TableCell>
                <TableCell>Nombre de heures</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {workflows.length > 0 &&
                tasks.length > 0 &&
                tasks.map((task, index) => (
                  <TableRow key={task.id}>
                    <TableCell>{task.dates.start}</TableCell>
                    <TableCell>{task.dates.due}</TableCell>
                    <TableCell>{task.title}</TableCell>
                    <TableCell>{getTimeTask(task)}</TableCell>
                    <TableCell>{getTypoColor(getWorkflowTask(task))}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            fullWidth="true"
            maxWidth="md"
          >
            <DialogTitle id="alert-dialog-slide-title">
              Créer une nouvelle tâche
            </DialogTitle>
            <DialogContent>
              <DialogContentText
                id="alert-dialog-slide-description"
                className={classes.dialContent}
              >
                <TextField
                  id="standard-basic"
                  label="Titre"
                  className={classes.dialContentTitle}
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
                <TextField
                  id="outlined-basic"
                  label="Description"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  multiline="true"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
                <div {...getRootProps()} className={classes.drop}>
                  <input {...getInputProps()} />
                  {isDragActive ? (
                    <p>Déplacer le fichier ici ...</p>
                  ) : (
                    <p>
                      Glissez et déposez les fichiers ici, ou cliquez pour
                      sélectionner des fichiers
                    </p>
                  )}
                </div>
                {files.map((f) => (
                  <span>{f.name}</span>
                ))}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Annuler
              </Button>
              <Button onClick={createTask} color="primary">
                Créer
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}
    </>
  );
}
